import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspMyRequestService {

  constructor(
    private http: HttpClient,
  ) { }

  myRequest(payload){
    // let paramData = {      
    //   userKey: userKey,
    //   garageKey: garageKey,
    //   source: "web" ,
    //   magicQuote:isMagic,
    //   insurerGarageKey:insurerGarageKey
      
    // };

    console.log('-----Get My Request-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/request/all', payload);
  }
   getInsurance(){
    let garageKey=localStorage.getItem("garageKey")
     return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/garage/insurance/'+garageKey);

  }
  // UpdateInsurance(requestId,isInsurance,insurerId){
  //   let merchantId=localStorage.getItem("merchantId")
  //       let params = {      
  //     userType: 'pitstopspare',
  //     requestId: requestId,
  //     isInsurance: isInsurance ,
  //     insurerId:insurerId,
  //     spareGarageId:merchantId
      
  //   };
  //    return this.http.post(`${GlobalVariable.BASE_API_URL}` + '/b2bupdatesparerequestevent', params=params);
  // }
    UpdateInsurance(requestId,isInsurance,insurerId) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      
    let merchantId=localStorage.getItem("merchantId")
    let notes;
    if(isInsurance==true){
      notes="Request Type changed from Insurance to Non-Insurance."
    }else{
      notes="Request Type changed from Non-Insurance to Insurance."
    }
  
      const url = `${GlobalVariable.BASE_API_URL}/b2bupdatesparerequestevent?userType=pitstopspare&spareGarageId=${merchantId}&requestId=${requestId}&isInsurance=${isInsurance}&insurerId=${insurerId}&notes=${notes}`;
  
      return this.http.post(url, {}, { headers });
    }
}
